import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 35px;
  border: 1px solid ${GrayColors["G-1-5"]};
  padding: 0 10px 0 0px;
  transition: border-color 100ms ease-out;

  border-radius: 6px;

  &:hover {
    transition: border-color 200ms ease-in;
    border-color: ${GrayColors["G-3"]};
  }
`;

export const Edit = styled.div`
  display: inline-flex;
  margin-left: 8px;
  color: ${SolutionColorVariables.sc1};
`;

export const Body = styled.button`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  flex-grow: 1;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;

  &:hover {
    ${Edit} {
      color: ${SolutionColorVariables.sc4};
    }
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const Info = styled.div`
  position: relative;

  display: inline-flex;
  padding-left: 9px;

  &:before {
    content: " ";

    position: absolute;
    top: 50%;
    left: 0;

    width: 1px;
    height: 22px;
    margin: auto 0;

    background-color: ${GrayColors["G-1"]};

    transform: translate(0, -50%);
  }
`;
